export class Project {
    projectId: number;
    projectName: string;
    description: string;
    longitude: string;
    lattitude: string;
    companyId: number;
    district: string;
}
